import { NgModule } from '@angular/core';
import { PermissionDirective } from '@core/permissions/directives/permission.directive';

@NgModule({
  imports: [],
  declarations: [PermissionDirective],
  exports: [PermissionDirective],
})
export class PermissionDirectiveModule {}
